import classNames from "classnames";
import React from "react";
import styles from "./widgetControlCircle.css";

interface Props {
  onClick: any;
  id?: string;
  off?: boolean;
  red?: boolean;
}

export const WidgetControlCircle: React.SFC<Props> = ({ onClick, id, off, red, children }) => (
  <button
    className={classNames(styles.control, { [styles.off]: off, [styles.red]: red })}
    onClick={onClick}
    id={id}
  >
    {children}
  </button>
);
